
















import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import DealerContact from '@/store/entities/admin/dealercontact';
import ListView from '@/components/helper/list-view.vue';
import ModalView from '@/components/helper/modal-view.vue';

@Component({
    components: { ListView, ModalView }
})
export default class ContactList extends ListBase {
    entity: string = 'dealercontact';
    dealercontact: DealerContact = new DealerContact();
    modalSetting: any = {
        entity: "dealercontact",
        title: 'Contacto',
        width: "400px"
    };

    items = [
        this.gItem({ type: 'object', prop: 'employee_id', label: 'Empleado', itemText: 'fullname' }),
        this.gItem({ type: 'object', prop: 'type_id', label: 'Puesto', generalType: 'POSITION_DEALER2' }),
    ]

    columns = [
        this.gCol('employee.fullname', 'Empleado', 'text', '', false),
        this.gColO({ type: 'text', value: 'type_id', text: 'Puesto', generalType: true }),
        this.defaultActions('edit|delete'),
    ]

    afterSave() {
        this.$emit('save-success');
    }

    edit() {
        this.modalShow = !this.modalShow;
    }
    create() {
        this.modalShow = !this.modalShow;
    }

    async created() {

    }
}
